/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from "three";
import React, { useMemo, useRef, useState } from "react";

import { params, const_var } from "../../../../../../redux/reducers/reducer";
import * as actionCreator from '../../../../../../action/index';
import { CSG } from "../../../../../../assets/libs/csg-lib";
import { delModel, extrudeSettings, railLoftModel, railModel, roofBaseRailModel } from "../../../../../../utils/Functions";
import { wallNameArrForValid } from "../../../../../../utils/Validation";
import { MaterialTruss } from "../../../../CustomMaterial";
// import CTCT from "./CTCT";
import { useDispatch } from "react-redux";
import VerticalLeg from "./VerticalLeg";
import GableLeantoTruss from "../../../GableLeantoTruss";

const Legs = ({ setLeanToTrussPosArr, normalMap = null, envMap = null, roofRailDistanceY=0, hangRailDivision=0}) => {
    const dispatch = useDispatch();   
    const angle = useMemo(() =>{
        return Math.atan(parseInt(params.b_l_t_r_pF) / 12);
    }, [params.b_l_t_r_pF]);

    const meshDelModel_CSG = useMemo(() => {
        let resultData = {}
        
        const wallValueArr = ['gableFrontLeanFront', 'gableFrontLeanBack', 'gableFrontLeanLeft', 'gableFrontLeanRight', 'gableFrontLeanStorageFront', 'gableFrontLeanStorageBack'];
        wallValueArr.forEach((item) => {
            const meshDelModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(delModel(item, 'leg'), extrudeSettings(3)),
                new THREE.MeshStandardMaterial({ color: 'red' })
            )
            const meshDelModel_Temp = meshDelModel.clone();
            if (item === 'gableFrontLeanFront' || item === 'gableFrontLeanBack'|| item === 'gableFrontLeanStorageFront') {
                meshDelModel_Temp.position.set(-params.leanF_p_pos, 0, -1.5)
            } else {
                meshDelModel_Temp.rotateY(Math.PI / 2)
                meshDelModel_Temp.position.set(-1.5, 0, 0)
            }
            meshDelModel_Temp.updateMatrix();
            meshDelModel_Temp.updateMatrixWorld();
            
            const mesh_CSG = CSG.fromMesh(meshDelModel_Temp);
            
            resultData = { ...resultData,  [item]: mesh_CSG };
        })

        return resultData;
    }, [const_var.newDoorsArray, params.leanF_p_pos]);
    
    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length > 0 && const_var.DistanceArr[params.p_b_t] != undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s] !== undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]]);
    
    const pillarWidth = 0.3;
    const pillarHeight = 0.2;
    const railWidth = 0.2;
    const railHeight = 0.3;
    const rungHRailLength = 3;
    const Temp_F_p_w = params.leanF_p_w - pillarWidth;
    const sideEdgeSlopeRailLength = 1.5;
    const sideEdgeSlopeRailAlpha = Math.PI / 3.2;
    const pillarNumber = Math.floor((params.leanF_p_d) / legDistance);
    const real_distance = (params.leanF_p_d) / pillarNumber;
    const railwidth = 0.2;
    const offset = 0.03;
    const ladderConnectDistance = 1;
    const zigzagConnectDistance = 1;
    let regularHeight = params.p_r_s === 1 ? const_var.roofRegularDst * 2 : 0;
    const ladderConnectNumber = Math.floor((params.leanF_p_h + regularHeight) / ladderConnectDistance);
    const zigzagConnectNumber = Math.floor((params.leanF_p_h + regularHeight) / zigzagConnectDistance) - 1;
    
    const [leftLegsDataArr, setLeftLegsDataArr] = useState([]);
    const [rightLegsDataArr, setRightLegsDataArr] = useState([]);
    const [legCount, setLegCount] = useState(0);

    const sideBracingType = const_var.selectedBracingForAddedBuilding.front_lean_side;
    const endBracingType = const_var.selectedBracingForAddedBuilding.front_lean_end;
    const endBracingDivider = (endBracingType == "invert_v_bracings" || endBracingType == "v_bracings") ? 4 : 2;
    const endBracingHeightVal = (endBracingType == "k_bay_bracings") ? -0.5 : 0;
    const sideBracingHeightVal = (sideBracingType == "k_bay_bracings") ? -0.5 : 0;

    
        
    const roofRegularOffsetHeight = useMemo(() => {
        let val = 0;
        if (params.p_r_s === 1) val = const_var.roofRegularDst * 2;
        else val = 0;

        return val;
    }, [params.p_r_s])
    
    const trussType = useMemo(() => {
        
        let trussObj =  const_var.leanGetDataFront?.truss_name
        let trussName = ""
        if(trussObj != undefined && trussObj.length > 0){
            trussObj.forEach((item)=>{
                if(item.is_show == 1 && ( params.l_t_p.front?.trussName == item.name.replace(/[0-9]/g, ''))){
                    trussName = item.name.replace(/[0-9]/g, '')
                }else{
                    trussName = (params.p_b_t === 27) ? 'Standard' : (params.leanF_p_w > 30) ? params.l_t_p.front?.trussName : (params.leanF_p_w > 24 && params.leanF_p_w <= 30) ? "TWCT" : ""
                }
            })
        }
        
        return trussName;
    }, [params.leanF_p_w, params.l_t_p.front?.trussName])

    const outInDistance = useMemo(() => {
        return  (params.leanF_p_e_l == true && const_var.leanFLegstype === "double") ? 0.21 :
                (params.leanF_p_e_l == true && const_var.leanFLegstype === "ladder") ? 0.5 :
                (params.leanF_p_e_l == true && const_var.leanFLegstype === "zigzag") ? 1 : 0;
    }, [const_var.leanFLegstype,params.leanF_p_e_l]);

    const obj_leftOuterPillar = new THREE.Object3D();
    const obj_leftInnerPillar = new THREE.Object3D();
    const obj_leftRoofRail = new THREE.Object3D();
    const obj_leftSlopeRail = new THREE.Object3D();
    const obj_leftLadderConnectRail = new THREE.Object3D();
    const obj_leftZigzagConnectRail = new THREE.Object3D();
    const obj_leftZigzagBottomRail = new THREE.Object3D();
    const obj_rightOuterPillar = new THREE.Object3D();
    const obj_rightInnerPillar = new THREE.Object3D();
    const obj_rightRoofRail = new THREE.Object3D();
    const obj_rightSlopeRail = new THREE.Object3D();
    const obj_rightLadderConnectRail = new THREE.Object3D();
    const obj_rightZigzagConnectRail = new THREE.Object3D();
    const obj_rightZigzagBottomRail = new THREE.Object3D();
    const obj_roofBaseRail = new THREE.Object3D();
    const obj_rungHRail = new THREE.Object3D();
    const obj_loftPieceRail = new THREE.Object3D();
        
    const [leftOuterPillar, setLeftOuterPillar] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [leftInnerPillar, setLeftInnerPillar] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [leftRoofRail, setLeftRoofRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [leftSlopeRail, setLeftSlopeRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [leftLadderConnectRail, setLeftLadderConnectRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [leftZigzagConnectRail, setLeftZigzagConnectRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [leftZigzagBottomRail, setLeftZigzagBottomRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [rightOuterPillar, setRightOuterPillar] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [rightInnerPillar, setRightInnerPillar] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [rightRoofRail, setRightRoofRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [rightSlopeRail, setRightSlopeRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [rightLadderConnectRail, setRightLadderConnectRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [rightZigzagConnectRail, setRightZigzagConnectRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [rightZigzagBottomRail, setRightZigzagBottomRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [roofBaseRail, setRoofBaseRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [rungHRail, setRungHRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([], 16)));
    const [loftPieceRail, setLoftPieceRail] = useState(new THREE.InstancedBufferAttribute(new Float32Array([]), 16));
    
    const sideEdgeSlopeRailPosY = useMemo(() => {
        return params.leanF_p_h + regularHeight - (sideEdgeSlopeRailLength * Math.sin(sideEdgeSlopeRailAlpha) - (sideEdgeSlopeRailLength * Math.cos(sideEdgeSlopeRailAlpha)) * Math.tan(angle));
    }, [params.leanF_p_h, regularHeight, sideEdgeSlopeRailLength, sideEdgeSlopeRailAlpha, angle]);

    const leftSideCmpArray = [...const_var.newDoorsArray.filter((item) => wallNameArrForValid.find(subArray => subArray.includes('G_F_L_L_W')).includes(item.userData.wallName))];
    const leftSideCmpStorageArray = [...const_var.newDoorsArray.filter((item) => wallNameArrForValid.find(subArray => subArray.includes('G_F_L_L_S_W')).includes(item.userData.wallName))];
    const rightsideCmpArray = [...const_var.newDoorsArray.filter((item) => wallNameArrForValid.find(subArray => subArray.includes('G_F_L_R_W')).includes(item.userData.wallName))];
    const rightSideCmpStorageArray = [...const_var.newDoorsArray.filter((item) => wallNameArrForValid.find(subArray => subArray.includes('G_F_L_R_S_W')).includes(item.userData.wallName))];

    const leftCmpArray = [...leftSideCmpArray, ...leftSideCmpStorageArray];
    const rightCmpArray = [...rightsideCmpArray, ...rightSideCmpStorageArray];


    const roofCutModelForBraceGeo = useMemo(() => {
        const thikness = 4
        const sideOverHang = params.leanF_p_w;
        const width = params.leanF_p_w
        const regularHeight = (params.p_r_s == 1) ? roofRegularOffsetHeight - 0.3 : 0

        const model = new THREE.Shape();
        model.moveTo(-((width / 2) + sideOverHang), params.leanF_p_h + regularHeight - ((params.b_l_t_r_pF/12) * (sideOverHang)));
        model.lineTo(0, params.leanF_p_h + regularHeight + ((params.b_l_t_r_pF/12) * (width / 2)));
        model.lineTo(((width / 2) + sideOverHang), params.leanF_p_h + regularHeight  - ((params.b_l_t_r_pF/12) * (sideOverHang)));
        model.lineTo(((width / 2) + sideOverHang), params.leanF_p_h + regularHeight  - ((params.b_l_t_r_pF/12) * (sideOverHang)) + thikness);
        model.lineTo(0, params.leanF_p_h + regularHeight + ((params.b_l_t_r_pF/12) * (width / 2)) + thikness);
        model.lineTo(-((width / 2) + sideOverHang), params.leanF_p_h + regularHeight  - ((params.b_l_t_r_pF/12) * (sideOverHang)) + thikness);

        return model;
    }, [params.leanF_p_w, params.leanF_p_h, params.b_l_t_r_pF,roofRegularOffsetHeight])

    const baseCutModelForBraceGeo = railModel(params.p_w, params.p_h);
    const baseCutModelForBraceMesh = new THREE.Mesh(
        new THREE.ExtrudeGeometry(baseCutModelForBraceGeo, extrudeSettings(params.leanF_p_d),
        new THREE.MeshStandardMaterial({ color: 'pink'})
        )
    )
    
    const roofCutMdelForBraceMesh = new THREE.Mesh(
        new THREE.ExtrudeGeometry(roofCutModelForBraceGeo, extrudeSettings(params.leanF_p_d),
        new THREE.MeshStandardMaterial({ color: 'pink' })
        )
    )

    const pillarRailDataArr = useMemo(() => {
        let dataInfoArray = [];
        let tempDataInfo;
        for (let index = 0; index <= pillarNumber; index++) {
            let pos_z;
            if (index === 0) {
                pos_z = pillarWidth + 0.1
            } else if (index === pillarNumber) {
                pos_z = params.leanF_p_d - pillarWidth / 2 - 0.05;
            } else {
                pos_z = index * real_distance + pillarWidth;
            }

            let connect_ladder_position_y = [];
            let connect_zigzag_position_y = [];
            for (let j = 0; j < ladderConnectNumber; j++) {
                connect_ladder_position_y.push(j * ladderConnectDistance);
            }
            for (let j = 0; j < zigzagConnectNumber; j++) {
                connect_zigzag_position_y.push(j * zigzagConnectDistance);
            }

            tempDataInfo = {
                pos_z: pos_z,
                leftOuter_pillar: {
                    length: params.leanF_p_h + regularHeight,
                    pos_y: 0,
                },
                rightOuter_pillar: {
                    length: params.leanF_p_h + regularHeight,
                    pos_y: 0,
                },
                leftInner_pillar: {
                    length: params.leanF_p_h + regularHeight + outInDistance * Math.tan(angle),
                    pos_y: 0,
                },
                rightInner_pillar: {
                    length: params.leanF_p_h + regularHeight + outInDistance * Math.tan(angle),
                    pos_y: 0,
                },
                leftRoof_rail: {
                    length: Temp_F_p_w / Math.cos(angle),
                    pos_y: params.leanF_p_h + regularHeight - pillarHeight / 2,
                },
                rightRoof_rail: {
                    length: Temp_F_p_w / Math.cos(angle),
                    pos_y: params.leanF_p_h + regularHeight - pillarHeight / 2,
                },
                rungH_rail: {
                    length: rungHRailLength,
                    pos_y: params.leanF_p_h + regularHeight + Temp_F_p_w / 2 * Math.tan(angle) - rungHRailLength / 2 * Math.tan(angle) - pillarHeight / 2,
                },
                sideSlope_rail: {
                    length: sideEdgeSlopeRailLength,
                    pos_y: sideEdgeSlopeRailPosY - pillarHeight / 2,
                },
                ladder_connect_pillar: {
                    length: outInDistance,
                    pos_y: connect_ladder_position_y
                },
                zigzag_connect_pillar: {
                    length: outInDistance / Math.sin(Math.PI / 4),
                    pos_y: connect_zigzag_position_y
                },
            }
            dataInfoArray.push(tempDataInfo);
            let posArr = [];
            dataInfoArray.map((item) => {
                posArr.push(-item.pos_z - params.p_d / 2)
            });
            setLeanToTrussPosArr(posArr);
            // push the valuse of porches leg position to highlight 
            let sortedPosArr = JSON.parse(JSON.stringify(posArr))
            sortedPosArr.sort(function(a, b){return a - b});
            dispatch(actionCreator.setLeanToLegPosObj(sortedPosArr, 'gableFrontLean'));
        }
        return dataInfoArray;

    }, [pillarNumber, real_distance, params.leanF_p_h, Temp_F_p_w, params.leanF_p_d, angle, params.p_d, regularHeight, outInDistance, sideEdgeSlopeRailPosY, ladderConnectNumber, zigzagConnectNumber]);

    const roofBaseRailArr = useMemo(() => {
        let dataInfoArray = [];
        let count, distance;
        const initRoofSpace = 0.5;
        let initDistance = 3.5;
        const tempCount = Math.floor((Temp_F_p_w / 2 - initRoofSpace) / initDistance);
        if ((Temp_F_p_w / 2 - initRoofSpace) === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if ((Temp_F_p_w / 2 - initRoofSpace) - tempCount * initDistance <= initDistance) {
            count = tempCount;
            distance = (Temp_F_p_w / 2 - initRoofSpace) / count;
        } else {
            count = tempCount + 1;
            distance = (Temp_F_p_w / 2 - initRoofSpace) / count;
        }

        for (let index = 0; index < count; index++) {
            const pos_z = initRoofSpace + distance * index - railwidth / 2;
            const pos_y = params.leanF_p_h + regularHeight + (Temp_F_p_w / 2 - pos_z) * Math.tan(angle) + 0.02 + 0.05 * Math.sin(angle) - offset;
            const tempInfoObj = {
                distance: distance,
                pos_z: pos_z,
                pos_y: pos_y,
                lengh: params.leanF_p_d
            }
            dataInfoArray.push(tempInfoObj);
        }
        return dataInfoArray;
    }, [Temp_F_p_w, params.leanF_p_h, params.leanF_p_d, regularHeight, angle]);

    useMemo(() => {
        const instancedMatLeftOuterPillar = []
        const instancedMatLeftInnerPillar = []
        const instancedMatLeftRoofRail = []
        const instancedMatLeftSlopeRail = []
        const instancedMatLeftLadderConnectRail = []
        const instancedMatLeftZigzagConnectRail = []
        const instancedMatLeftZigzagBottomRail = []
        const instancedMatRightOuterPillar = []
        const instancedMatRightInnerPillar = []
        const instancedMatRightRoofRail = []
        const instancedMatRightSlopeRail = []
        const instancedMatRightLadderConnectRail = []
        const instancedMatRightZigzagConnectRail = []
        const instancedMatRightZigzagBottomRail = []
        const instancedMatRungHRail = []
        
            let leftCutLegsArr = [];
            let rightCutLegsArr = [];
            pillarRailDataArr.map((item, index) => {
                let leftflag = false;
                let rightflag = false;
                leftCmpArray.forEach((doorItem, doorIndex) => {
                    if ((Math.abs(item.pos_z) <= doorItem.positionX - params.p_d / 2 + doorItem.width / 2 + pillarWidth / 2) && (Math.abs(item.pos_z) >= doorItem.positionX - params.p_d / 2 - doorItem.width / 2 - pillarWidth / 2)) {
                        leftflag = true;
                    }
                });
                rightCmpArray.forEach((doorItem, doorIndex) => {
                    if ((Math.abs(item.pos_z) <= Math.abs(doorItem.positionX) - params.p_d / 2 + doorItem.width / 2 + pillarWidth / 2) && (Math.abs(item.pos_z) >= Math.abs(doorItem.positionX) - params.p_d / 2 - doorItem.width / 2 - pillarWidth / 2)) {
                        rightflag = true;
                    }
                });
                leftCutLegsArr.push(leftflag);
                rightCutLegsArr.push(rightflag);
                obj_leftOuterPillar.position.set( - Temp_F_p_w / 2, 0, item.pos_z + params.p_d / 2);
                obj_leftOuterPillar.rotation.x = - Math.PI / 2;
                if (leftflag === true) {
                    obj_leftOuterPillar.scale.setScalar(0);
                } else {
                    obj_leftOuterPillar.scale.setScalar(1);
                }
                obj_leftOuterPillar.updateMatrix();
                instancedMatLeftOuterPillar.push(...obj_leftOuterPillar.matrix.elements);

                obj_rightOuterPillar.position.set(Temp_F_p_w / 2, 0, item.pos_z + params.p_d / 2);
                obj_rightOuterPillar.rotation.x = - Math.PI / 2;
                if (rightflag === true) {
                    obj_rightOuterPillar.scale.setScalar(0);
                } else {
                    obj_rightOuterPillar.scale.setScalar(1);
                }
                obj_rightOuterPillar.updateMatrix();
                instancedMatRightOuterPillar.push(...obj_rightOuterPillar.matrix.elements);

                obj_leftInnerPillar.position.set( - Temp_F_p_w / 2 + outInDistance, 0, item.pos_z + params.p_d / 2);
                obj_leftInnerPillar.rotation.x = - Math.PI / 2;
                if (leftflag === true || const_var.leanFLegstype === 'single') {
                    obj_leftInnerPillar.scale.setScalar(0);
                } else {
                    obj_leftInnerPillar.scale.setScalar(1);
                }
                obj_leftInnerPillar.updateMatrix();
                instancedMatLeftInnerPillar.push(...obj_leftInnerPillar.matrix.elements);

                obj_rightInnerPillar.position.set(Temp_F_p_w / 2 - outInDistance, 0, item.pos_z + params.p_d / 2);
                obj_rightInnerPillar.rotation.x = - Math.PI / 2;
                if (rightflag === true || const_var.leanFLegstype === 'single') {
                    obj_rightInnerPillar.scale.setScalar(0);
                } else {
                    obj_rightInnerPillar.scale.setScalar(1);
                }
                obj_rightInnerPillar.updateMatrix();
                instancedMatRightInnerPillar.push(...obj_rightInnerPillar.matrix.elements);

                obj_leftRoofRail.position.set( -(Temp_F_p_w / 2 - (params.p_r_s === 1 && (const_var.roofRegularDst - 0.13))), item.leftRoof_rail.pos_y - offset + (params.p_r_s === 1 && (const_var.roofRegularDst - 0.13) * Math.tan(angle)), item.pos_z + params.p_d / 2);
                obj_leftRoofRail.rotation.y = Math.PI / 2;
                obj_leftRoofRail.rotateOnAxis(new THREE.Vector3(1, 0, 0), - angle);
                obj_leftRoofRail.updateMatrix();
                instancedMatLeftRoofRail.push(...obj_leftRoofRail.matrix.elements);

                obj_rightRoofRail.position.set((Temp_F_p_w / 2 - (params.p_r_s === 1 && (const_var.roofRegularDst - 0.13))), item.rightRoof_rail.pos_y - offset + (params.p_r_s === 1 && (const_var.roofRegularDst - 0.13) * Math.tan(angle)), item.pos_z + params.p_d / 2);
                obj_rightRoofRail.rotation.y = - Math.PI / 2;
                obj_rightRoofRail.rotateOnAxis(new THREE.Vector3(1, 0, 0), - angle);
                obj_rightRoofRail.updateMatrix();
                instancedMatRightRoofRail.push(...obj_rightRoofRail.matrix.elements);

                obj_rungHRail.position.set(rungHRailLength / 2, item.rungH_rail.pos_y - offset, item.pos_z + params.p_d / 2);
                obj_rungHRail.rotation.y = - Math.PI / 2;
                if (trussType === "") {
                    obj_rungHRail.scale.setScalar(1);
                } else {
                    obj_rungHRail.scale.setScalar(0);
                }
                obj_rungHRail.updateMatrix();
                instancedMatRungHRail.push(...obj_rungHRail.matrix.elements);

                obj_leftSlopeRail.position.set( - Temp_F_p_w / 2, item.sideSlope_rail.pos_y - offset, item.pos_z + params.p_d / 2);
                obj_leftSlopeRail.rotation.y = Math.PI / 2;
                obj_leftSlopeRail.rotateOnAxis(new THREE.Vector3(1, 0, 0), - (sideEdgeSlopeRailAlpha));
                if (trussType === "") {
                    obj_leftSlopeRail.scale.setScalar(1);
                } else {
                    obj_leftSlopeRail.scale.setScalar(0);
                }
                obj_leftSlopeRail.updateMatrix();
                instancedMatLeftSlopeRail.push(...obj_leftSlopeRail.matrix.elements);

                obj_rightSlopeRail.position.set(Temp_F_p_w / 2, item.sideSlope_rail.pos_y - offset, item.pos_z + params.p_d / 2);
                obj_rightSlopeRail.rotation.y = - Math.PI / 2;
                obj_rightSlopeRail.rotateOnAxis(new THREE.Vector3(1, 0, 0), - (sideEdgeSlopeRailAlpha));
                if (trussType === "") {
                    obj_rightSlopeRail.scale.setScalar(1);
                } else {
                    obj_rightSlopeRail.scale.setScalar(0);
                }
                obj_rightSlopeRail.updateMatrix();
                instancedMatRightSlopeRail.push(...obj_rightSlopeRail.matrix.elements);

                // ladder connect
                item.ladder_connect_pillar.pos_y.map((connect_item, connect_index) => {
                    const ladderHeight = connect_index * ladderConnectDistance + pillarHeight / 2;
                    obj_leftLadderConnectRail.position.set( - Temp_F_p_w / 2, ladderHeight, item.pos_z + params.p_d / 2);
                    obj_leftLadderConnectRail.rotation.y = Math.PI / 2;
                    let leftIsLadder = false;
                    if (const_var.leanFLegstype === "ladder") {
                        leftCmpArray.forEach((doorItem, doorIndex) => {
                            if ((Math.abs(item.pos_z) <= doorItem.positionX - params.p_d / 2 + doorItem.width / 2 + pillarWidth / 2) && (Math.abs(item.pos_z) >= doorItem.positionX - params.p_d / 2 - doorItem.width / 2 - pillarWidth / 2) && (ladderHeight <= doorItem.positionY + doorItem.height / 2 + pillarHeight / 2) && (ladderHeight >= doorItem.positionY - doorItem.height / 2 - pillarHeight / 2)) {
                                leftIsLadder = true;
                            }
                        })
                        if (leftIsLadder) {
                            obj_leftLadderConnectRail.scale.setScalar(0);
                        } else {
                            obj_leftLadderConnectRail.scale.setScalar(1);
                        }
                    } else {
                        obj_leftLadderConnectRail.scale.setScalar(0);
                    }
                    obj_leftLadderConnectRail.updateMatrix();
                    instancedMatLeftLadderConnectRail.push(...obj_leftLadderConnectRail.matrix.elements);

                    obj_rightLadderConnectRail.position.set(Temp_F_p_w / 2, ladderHeight, item.pos_z + params.p_d / 2);
                    obj_rightLadderConnectRail.rotation.y = - Math.PI / 2;
                    let rightIsLadder = false;
                    if (const_var.leanFLegstype === "ladder") {
                        rightCmpArray.forEach((doorItem, doorIndex) => {
                            if ((Math.abs(item.pos_z) <= Math.abs(doorItem.positionX) - params.p_d / 2 + doorItem.width / 2 + pillarWidth / 2) && (Math.abs(item.pos_z) >= Math.abs(doorItem.positionX) - params.p_d / 2 - doorItem.width / 2 - pillarWidth / 2) && (ladderHeight <= doorItem.positionY + doorItem.height / 2 + pillarHeight / 2) && (ladderHeight >= doorItem.positionY - doorItem.height / 2 - pillarHeight / 2)) {
                                rightIsLadder = true;
                            }
                        })
                        if (rightIsLadder) {
                            obj_rightLadderConnectRail.scale.setScalar(0);
                        } else {
                            obj_rightLadderConnectRail.scale.setScalar(1);
                        }
                    } else {
                        obj_rightLadderConnectRail.scale.setScalar(0);
                    }
                    obj_rightLadderConnectRail.updateMatrix();
                    instancedMatRightLadderConnectRail.push(...obj_rightLadderConnectRail.matrix.elements);
                });
                
                // zigzag connect
                item.zigzag_connect_pillar.pos_y.map((connect_item, connect_index) => {
                    const zigzagHeight = connect_index * zigzagConnectDistance - pillarHeight / 2;
                    if (connect_index % 2 === 0) {
                        obj_leftZigzagConnectRail.position.set( - Temp_F_p_w / 2, (connect_index + 1) * zigzagConnectDistance + pillarHeight, item.pos_z + params.p_d / 2);
                        obj_leftZigzagConnectRail.rotation.y = Math.PI / 4;
                        obj_leftZigzagConnectRail.rotation.x = Math.PI / 2;
                        
                    } else {
                        obj_leftZigzagConnectRail.position.set( - Temp_F_p_w / 2, connect_index * zigzagConnectDistance + pillarHeight, item.pos_z + params.p_d / 2);
                        obj_leftZigzagConnectRail.rotation.y = Math.PI / 4;
                        obj_leftZigzagConnectRail.rotation.x =  - Math.PI / 2;
                    }
                    let leftIsZigzag = false;
                    if (const_var.leanFLegstype === "zigzag") {
                        leftCmpArray.forEach((doorItem, doorIndex) => {
                            if ((Math.abs(item.pos_z) <= Math.abs(doorItem.positionX) - params.p_d / 2 + doorItem.width / 2 + pillarWidth / 2) && (Math.abs(item.pos_z) >= Math.abs(doorItem.positionX) - params.p_d / 2 - doorItem.width / 2 - pillarWidth / 2) && (zigzagHeight <= doorItem.positionY + doorItem.height / 2 + pillarHeight / 2) && (zigzagHeight >= doorItem.positionY - doorItem.height / 2 - pillarHeight - zigzagConnectDistance)) {
                                leftIsZigzag = true;
                            }
                        });
                        if (leftIsZigzag) {
                            obj_leftZigzagConnectRail.scale.setScalar(0);
                        } else {
                            obj_leftZigzagConnectRail.scale.setScalar(1);
                        }
                    } else {
                        obj_leftZigzagConnectRail.scale.setScalar(0);
                    }
                    obj_leftZigzagConnectRail.updateMatrix();
                    instancedMatLeftZigzagConnectRail.push(...obj_leftZigzagConnectRail.matrix.elements);

                    if (connect_index % 2 === 0) {
                        obj_rightZigzagConnectRail.position.set(Temp_F_p_w / 2, (connect_index + 1) * zigzagConnectDistance + pillarHeight,  item.pos_z + params.p_d / 2);
                        obj_rightZigzagConnectRail.rotation.y = - Math.PI / 4;
                        obj_rightZigzagConnectRail.rotation.x = Math.PI / 2;
                    } else {
                        obj_rightZigzagConnectRail.position.set(Temp_F_p_w / 2, connect_index * zigzagConnectDistance + pillarHeight,  item.pos_z + params.p_d / 2);
                        obj_rightZigzagConnectRail.rotation.y = - Math.PI / 4;
                        obj_rightZigzagConnectRail.rotation.x = - Math.PI / 2;
                    }
                    let rightIsZigzag = false;
                    if (const_var.leanFLegstype === "zigzag") {
                        rightCmpArray.forEach((doorItem, doorIndex) => {
                            if ((Math.abs(item.pos_z) <= Math.abs(doorItem.positionX) - params.p_d / 2 + doorItem.width / 2 + pillarWidth / 2) && (Math.abs(item.pos_z) >= Math.abs(doorItem.positionX) - params.p_d / 2 - doorItem.width / 2 - pillarWidth / 2) && (zigzagHeight <= doorItem.positionY + doorItem.height / 2 + pillarHeight / 2) && (zigzagHeight >= doorItem.positionY - doorItem.height / 2 - pillarHeight - zigzagConnectDistance)) {
                                rightIsZigzag = true;
                            }
                        });
                        if (rightIsZigzag) {
                            obj_rightZigzagConnectRail.scale.setScalar(0);
                        } else {
                            obj_rightZigzagConnectRail.scale.setScalar(1);
                        }
                    } else {
                        obj_rightZigzagConnectRail.scale.setScalar(0);
                    }
                    obj_rightZigzagConnectRail.updateMatrix();
                    instancedMatRightZigzagConnectRail.push(...obj_rightZigzagConnectRail.matrix.elements);
                });

                const zigzagHeight = 0;
                obj_leftZigzagBottomRail.position.set( -Temp_F_p_w / 2, pillarHeight / 2, item.pos_z + params.p_d / 2);
                obj_leftZigzagBottomRail.rotation.y = Math.PI / 2;
                let leftIsZigzag = false;
                if (const_var.leanFLegstype === "zigzag") {
                    leftCmpArray.forEach((doorItem, doorIndex) => {
                        if ((Math.abs(item.pos_z) <= Math.abs(doorItem.positionX) - params.p_d / 2 + doorItem.width / 2 + pillarWidth / 2) && (Math.abs(item.pos_z) >= Math.abs(doorItem.positionX) - params.p_d / 2 - doorItem.width / 2 - pillarWidth / 2) && (zigzagHeight <= doorItem.positionY + doorItem.height / 2 + pillarHeight / 2) && (zigzagHeight >= doorItem.positionY - doorItem.height / 2 - pillarHeight)) {
                            leftIsZigzag = true;
                        }
                    });
                    if (leftIsZigzag) {
                        obj_leftZigzagBottomRail.scale.setScalar(0);
                    } else {
                        obj_leftZigzagBottomRail.scale.setScalar(1);
                    }
                } else {
                    obj_leftZigzagBottomRail.scale.setScalar(0);
                }
                obj_leftZigzagBottomRail.updateMatrix();
                instancedMatLeftZigzagBottomRail.push(...obj_leftZigzagBottomRail.matrix.elements);

                obj_rightZigzagBottomRail.position.set(Temp_F_p_w / 2, pillarHeight / 2, item.pos_z + params.p_d / 2);
                obj_rightZigzagBottomRail.rotation.y = -Math.PI / 2;
                let rightIsZigzag = false;
                if (const_var.leanFLegstype === "zigzag") {
                    rightCmpArray.forEach((doorItem, doorIndex) => {
                        if ((Math.abs(item.pos_z) <= Math.abs(doorItem.positionX) - params.p_d / 2 + doorItem.width / 2 + pillarWidth / 2) && (Math.abs(item.pos_z) >= Math.abs(doorItem.positionX) - params.p_d / 2 - doorItem.width / 2 - pillarWidth / 2) && (zigzagHeight <= doorItem.positionY + doorItem.height / 2 + pillarHeight / 2) && (zigzagHeight >= doorItem.positionY - doorItem.height / 2 - pillarHeight)) {
                            rightIsZigzag = true;
                        }
                    });
                    if (rightIsZigzag) {
                        obj_rightZigzagBottomRail.scale.setScalar(0);
                    } else {
                        obj_rightZigzagBottomRail.scale.setScalar(1);
                    }
                } else {
                    obj_rightZigzagBottomRail.scale.setScalar(0);
                }
                obj_rightZigzagBottomRail.updateMatrix();
                instancedMatRightZigzagBottomRail.push(...obj_rightZigzagBottomRail.matrix.elements);
            });
            setLeftLegsDataArr(leftCutLegsArr);
            setRightLegsDataArr(rightCutLegsArr);
                        
            setLeftOuterPillar(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatLeftOuterPillar), 16));
            setLeftInnerPillar(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatLeftInnerPillar), 16));
            setLeftRoofRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatLeftRoofRail), 16));
            setLeftSlopeRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatLeftSlopeRail), 16));
            setLeftLadderConnectRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatLeftLadderConnectRail), 16));
            setLeftZigzagConnectRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatLeftZigzagConnectRail), 16));
            setLeftZigzagBottomRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatLeftZigzagBottomRail), 16));
            setRightOuterPillar(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatRightOuterPillar), 16));
            setRightInnerPillar(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatRightInnerPillar), 16));
            setRightRoofRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatRightRoofRail), 16));
            setRightSlopeRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatRightSlopeRail), 16));
            setRightLadderConnectRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatRightLadderConnectRail), 16));
            setRightZigzagConnectRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatRightZigzagConnectRail), 16));
            setRightZigzagBottomRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatRightZigzagBottomRail), 16));
            setRungHRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatRungHRail), 16));
    }, [pillarRailDataArr, outInDistance, angle, sideEdgeSlopeRailAlpha, ladderConnectDistance, params.p_d, const_var.newDoorsArray, const_var.leanFLegstype]);

    useMemo(() => {
        const instancedMatRoofBaseRail = []
            let index_all = 0;
            new Array(2).fill("").forEach((_, index_dir) => {
                let offsetForDir = index_dir === 0 ? 1 : -1;
                roofBaseRailArr.forEach((item_roof_rail, index) => {
                    obj_roofBaseRail.position.set( -pillarWidth / 2, item_roof_rail.pos_y, offsetForDir * item_roof_rail.pos_z);
                    obj_roofBaseRail.rotation.y = - Math.PI / 2;
                    obj_roofBaseRail.rotation.z = offsetForDir * - angle;
                    params.p_r_s === 3 ? obj_roofBaseRail.scale.setScalar(1) : obj_roofBaseRail.scale.setScalar(0);
                    obj_roofBaseRail.updateMatrix();
                    instancedMatRoofBaseRail.push(...obj_roofBaseRail.matrix.elements);
                    index_all ++;
                });
            });
            setRoofBaseRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedMatRoofBaseRail), 16));
    }, [roofBaseRailArr, params.p_r_s, angle]);

    const leftPillarModel = useMemo(() => {
        let leftOuterPillarArr = [];
        let leftInnerPillarArr = [];
        const leftOuterPillar = new THREE.Mesh(new THREE.ExtrudeGeometry(railModel(pillarHeight, pillarWidth), extrudeSettings(params.leanF_p_h)));
        const leftInnerPillar = new THREE.Mesh(new THREE.ExtrudeGeometry(railModel(pillarHeight, pillarWidth), extrudeSettings(params.leanF_p_h + outInDistance * Math.tan(angle) - pillarWidth / 2)));
        const meshDoorDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanLeft', 'leg'), extrudeSettings(3)), new THREE.MeshStandardMaterial({ color: 'red' }));
        let meshDoorDelModel_Temp = meshDoorDelModel.clone();
        meshDoorDelModel_Temp.position.set(-Temp_F_p_w / 2 - 1, 0, 0);
        meshDoorDelModel_Temp.rotation.set(0, Math.PI / 2, 0);
        meshDoorDelModel_Temp.updateMatrixWorld();
        const meshDoorDelModel_CSG = CSG.fromMesh(meshDoorDelModel_Temp);

        pillarRailDataArr.forEach((item, index) => {
            let leftOuterPillar_Temp = leftOuterPillar.clone();
            leftOuterPillar_Temp.position.set(-Temp_F_p_w / 2, 0,item.pos_z + params.p_d / 2);
            leftOuterPillar_Temp.rotation.set(-Math.PI / 2, 0, 0);
            leftOuterPillar_Temp.updateMatrix();
            leftOuterPillar_Temp.updateMatrixWorld();
            const meshLeftOuterPillar_CSG = CSG.fromMesh(leftOuterPillar_Temp);
            const meshLeftOuterPillarDeleted_CSG = meshLeftOuterPillar_CSG.subtract(meshDoorDelModel_CSG);
            const meshLeftOuterPillarDeleted = CSG.toMesh(
                meshLeftOuterPillarDeleted_CSG,
                new THREE.Matrix4()
            );
            let leftInnerPillar_Temp = leftInnerPillar.clone();
            leftInnerPillar_Temp.position.set(-Temp_F_p_w / 2 + outInDistance, 0, item.pos_z + params.p_d / 2);
            leftInnerPillar_Temp.rotation.set(-Math.PI / 2, 0, 0);
            leftInnerPillar_Temp.updateMatrix();
            leftInnerPillar_Temp.updateMatrixWorld();
            const meshLeftInnerPillar_CSG = CSG.fromMesh(leftInnerPillar_Temp);
            const meshLeftInnerPillarDeleted_CSG = meshLeftInnerPillar_CSG.subtract(meshDoorDelModel_CSG);
            const meshLeftInnerPillarDeleted = CSG.toMesh(
                meshLeftInnerPillarDeleted_CSG,
                new THREE.Matrix4()
            );
            leftOuterPillarArr.push(meshLeftOuterPillarDeleted.geometry);
            leftInnerPillarArr.push(meshLeftInnerPillarDeleted.geometry);
        });
        return {leftOuterPillarArr, leftInnerPillarArr};
    }, [params.leanF_p_h, leftLegsDataArr, const_var.newDoorsArray, outInDistance, angle]);

    const rightPillarModel = useMemo(() => {
        let rightOuterPillarArr = [];
        let rightInnerPillarArr = [];
        const rightOuterPillar = new THREE.Mesh(new THREE.ExtrudeGeometry(railModel(pillarHeight, pillarWidth), extrudeSettings(params.leanF_p_h)));
        const rightInnerPillar = new THREE.Mesh(new THREE.ExtrudeGeometry(railModel(pillarHeight, pillarWidth), extrudeSettings(params.leanF_p_h + outInDistance * Math.tan(angle) - pillarWidth / 2)));
        const meshDoorDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanRight', 'leg'), extrudeSettings(3)), new THREE.MeshStandardMaterial({ color: 'red' }));
        let meshDoorDelModel_Temp = meshDoorDelModel.clone();
        meshDoorDelModel_Temp.position.set(Temp_F_p_w / 2 - 2, 0, 0);
        meshDoorDelModel_Temp.rotation.set(0, Math.PI / 2, 0);
        meshDoorDelModel_Temp.updateMatrixWorld();
        const meshDoorDelModel_CSG = CSG.fromMesh(meshDoorDelModel_Temp);

        pillarRailDataArr.forEach((item, index) => {
            let rightOuterPillar_Temp = rightOuterPillar.clone();
            rightOuterPillar_Temp.position.set(Temp_F_p_w / 2, 0, item.pos_z + params.p_d / 2);
            rightOuterPillar_Temp.rotation.set(-Math.PI / 2, 0, 0);
            rightOuterPillar_Temp.updateMatrix();
            rightOuterPillar_Temp.updateMatrixWorld();
            const meshLeftOuterPillar_CSG = CSG.fromMesh(rightOuterPillar_Temp);
            const meshLeftOuterPillarDeleted_CSG = meshLeftOuterPillar_CSG.subtract(meshDoorDelModel_CSG);
            const meshLeftOuterPillarDeleted = CSG.toMesh(
                meshLeftOuterPillarDeleted_CSG,
                new THREE.Matrix4()
            );
            let rightInnerPillar_Temp = rightInnerPillar.clone();
            rightInnerPillar_Temp.position.set(Temp_F_p_w / 2 - outInDistance, 0, item.pos_z + params.p_d / 2);
            rightInnerPillar_Temp.rotation.set(-Math.PI / 2, 0, 0);
            rightInnerPillar_Temp.updateMatrix();
            rightInnerPillar_Temp.updateMatrixWorld();
            const meshLeftInnerPillar_CSG = CSG.fromMesh(rightInnerPillar_Temp);
            const meshLeftInnerPillarDeleted_CSG = meshLeftInnerPillar_CSG.subtract(meshDoorDelModel_CSG);
            const meshLeftInnerPillarDeleted = CSG.toMesh(
                meshLeftInnerPillarDeleted_CSG,
                new THREE.Matrix4()
            );
            rightOuterPillarArr.push(meshLeftOuterPillarDeleted.geometry);
            rightInnerPillarArr.push(meshLeftInnerPillarDeleted.geometry);
        });
        return {rightOuterPillarArr, rightInnerPillarArr};
    }, [params.leanF_p_h, rightLegsDataArr, const_var.newDoorsArray, outInDistance, angle]);

    const leftBottomBaseRailModel = useMemo(() => {
        const leftBottomBaseRail = new THREE.Mesh(new THREE.ExtrudeGeometry(railModel(pillarHeight, pillarWidth), extrudeSettings(params.leanF_p_d - pillarWidth)));
        let leftBottomBaseRail_Temp = leftBottomBaseRail.clone();
        leftBottomBaseRail_Temp.position.set(-Temp_F_p_w / 2, pillarWidth / 2, params.p_d / 2 + pillarWidth);
        leftBottomBaseRail_Temp.updateMatrix();
        leftBottomBaseRail_Temp.updateMatrixWorld();
        const leftBottomBaseRail_Temp_CSG = CSG.fromMesh(leftBottomBaseRail_Temp);

        const meshDoorDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanLeft', 'leg'), extrudeSettings(2)), new THREE.MeshStandardMaterial({ color: 'red' }));
        let meshDoorDelModel_Temp = meshDoorDelModel.clone();
        meshDoorDelModel_Temp.position.set( -Temp_F_p_w / 2 - 1, 0, 0);
        meshDoorDelModel_Temp.rotation.set(0, Math.PI / 2, 0);
        meshDoorDelModel_Temp.updateMatrixWorld();
        const meshDoorDelModel_CSG = CSG.fromMesh(meshDoorDelModel_Temp);
        const meshLeftBottomRailDeleted_CSG = leftBottomBaseRail_Temp_CSG.subtract(meshDoorDelModel_CSG);
        const meshLeftBottomRailDeleted = CSG.toMesh(
            meshLeftBottomRailDeleted_CSG,
            new THREE.Matrix4()
        );
        return meshLeftBottomRailDeleted.geometry;
    }, [params.p_d, params.leanF_p_d, Temp_F_p_w, const_var.newDoorsArray]);

    const rightBottomBaseRailModel = useMemo(() => {
        const rightBottomBaseRail = new THREE.Mesh(new THREE.ExtrudeGeometry(railModel(pillarHeight, pillarWidth), extrudeSettings(params.leanF_p_d - pillarWidth)));
        let rightBottomBaseRail_Temp = rightBottomBaseRail.clone();
        rightBottomBaseRail_Temp.position.set(Temp_F_p_w / 2, pillarWidth / 2, params.p_d / 2 + pillarWidth);
        rightBottomBaseRail_Temp.updateMatrix();
        rightBottomBaseRail_Temp.updateMatrixWorld();
        const rightBottomBaseRail_Temp_CSG = CSG.fromMesh(rightBottomBaseRail_Temp);

        const meshDoorDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanRight', 'leg'), extrudeSettings(2)), new THREE.MeshStandardMaterial({ color: 'red' }));
        let meshDoorDelModel_Temp = meshDoorDelModel.clone();
        meshDoorDelModel_Temp.position.set(Temp_F_p_w / 2 - 1, 0, 0);
        meshDoorDelModel_Temp.rotation.set(0, Math.PI / 2, 0);
        meshDoorDelModel_Temp.updateMatrixWorld();
        const meshDoorDelModel_CSG = CSG.fromMesh(meshDoorDelModel_Temp);
        const meshLeftBottomRailDeleted_CSG = rightBottomBaseRail_Temp_CSG.subtract(meshDoorDelModel_CSG);
        const meshLeftBottomRailDeleted = CSG.toMesh(
            meshLeftBottomRailDeleted_CSG,
            new THREE.Matrix4()
        );
        return meshLeftBottomRailDeleted.geometry;
    }, [params.p_d, params.leanF_p_d, Temp_F_p_w, const_var.newDoorsArray]);
    
    const roofRailLength = useMemo(() => {
        let val = 0;
        if (params.p_r_s === 1) val = Math.sqrt(Math.pow(params.leanF_p_w / 2 - const_var.roofRegularDst, 2) + Math.pow((params.leanF_p_w / 2 - const_var.roofRegularDst) * params.b_l_t_r_pF / 12, 2))
        else val = Temp_F_p_w / 2 / Math.cos(angle) + pillarHeight / 2 * Math.sin(angle);
        return val;
    }, [params.p_r_s, params.leanF_p_w, params.leanF_p_w, params.b_l_t_r_pF, angle])

    const legDistanceNew = useMemo(() => {
        let distance = 0;
        if (pillarRailDataArr.length > 1) distance = pillarRailDataArr[1].pos_z - pillarRailDataArr[0].pos_z;

        return distance;
    }, [pillarRailDataArr])
    
    const hiddenBaseRailIdArr = useMemo(() => {
        let isHiddenBaseRailIndexArr = [];
        const heightestDoorArr = const_var.newDoorsArray.filter(e => (e.height > params.leanF_p_h) || (e.positionY + e.height / 2 >= params.leanF_p_h));

        let centerBuildingWall = heightestDoorArr.find(item => item.userData.wallName === 'c_b_f_w')
        if(centerBuildingWall && params.leanF_p_pos + params.leanF_p_w/2 + centerBuildingWall.width/2 > centerBuildingWall.position.positionX && params.leanF_p_pos - params.leanF_p_w/2 - centerBuildingWall.width/2 < centerBuildingWall.position.positionX) isHiddenBaseRailIndexArr.push(pillarRailDataArr?.length - 1)
        
        if(heightestDoorArr.find(item => item.userData.wallName === 'G_F_L_B_W')) isHiddenBaseRailIndexArr.push(pillarRailDataArr?.length - 1)
        if(heightestDoorArr.find(item => item.userData.wallName === 'G_F_L_F_W')) isHiddenBaseRailIndexArr.push(0)
        if(params.leanF_p_d % legDistance === 0){
            if(heightestDoorArr.find(item => item.userData.wallName === 'G_F_L_F_S_W')) isHiddenBaseRailIndexArr.push(parseInt( params.leanF_p_d - params.add_storage_front) / legDistance)
        }
        
        return isHiddenBaseRailIndexArr;
    }, [params.leanF_p_h, const_var.newDoorsArray, params.add_storage_front, params.leanF_p_d, legDistance, params.leanF_p_pos])

    const sidePillarRailDataArr = useMemo(() => {
        let sideCrossBracingHorizonTruss = []
        let sideCrossBracingSlopeTruss = []
        let count, distance = 0;
        let horizonTrussCount = 0
        
        const initDistance = real_distance;
        const tempCount = Math.floor(params.leanF_p_d / initDistance);
        if (params.leanF_p_d === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (params.leanF_p_d - tempCount * initDistance < initDistance / 2) {
            count = tempCount;
            distance = params.leanF_p_d / count;
        } else {
            count = tempCount + 1;
            distance = params.leanF_p_d / count;
        }
        setLegCount(count)

        let divider = (sideBracingType == "v_bracings" || sideBracingType == "invert_v_bracings") ? 2 : 1
        const horizonTrussDistance = (distance / 2) / 4 * 5;
        const tempHorizonTrussCount = Math.floor(params.leanF_p_h / horizonTrussDistance)
        const slopeTrussAngle = Math.atan((distance/divider) / (horizonTrussDistance))
        const slopeTrussLength = Math.sqrt(Math.pow(horizonTrussDistance, 2) + Math.pow((distance/divider), 2)) - 0.14

        if (params.leanF_p_h > horizonTrussDistance * tempHorizonTrussCount) {
            horizonTrussCount = tempHorizonTrussCount + 1;
        } else {
            horizonTrussCount = tempHorizonTrussCount;
        }
        
        // front end cross bracing legs and horizon, slope truss
        for(let i = 0; i < 2; i++) {
            let pos_Z = 0;
            
            if(i === 0) {
                pos_Z = params.p_d / 2 + pillarWidth + 0.05

                for(let j = 1; j < horizonTrussCount; j++) {
                    let pos_y;
                    pos_y = horizonTrussDistance * j + 0.25;
                    const tempHorizonTrussInfoObj = {
                        pos_Z: pos_Z,
                        pos_y: pos_y - railWidth / 2,
                        length: distance
                    }
                    sideCrossBracingHorizonTruss.push(tempHorizonTrussInfoObj)
                }
                for(let k = sideBracingHeightVal; k < horizonTrussCount - 1; k++) {
                    let pos_y;
                    pos_y = horizonTrussDistance * k + 0.25;
                    const tempSlopeTrussInfoObj = {
                        pos_Z: pos_Z + distance,
                        pos_y: pos_y - railWidth / 2,
                        length: slopeTrussLength,
                        rotationX : -(Math.PI / 2 + slopeTrussAngle)
                    }
                    sideCrossBracingSlopeTruss.push(tempSlopeTrussInfoObj)
                }
            } else if (i === 1) {
                let pos_y;
                const offsetSize = 0.2;
                pos_Z = params.p_d / 2 + params.leanF_p_d - distance + offsetSize
                
                for(let j = 1; j < horizonTrussCount; j++) {
                    pos_y = horizonTrussDistance * j + 0.25;
                    const tempHorizonTrussInfoObj = {
                        pos_Z: pos_Z,
                        pos_y: pos_y - railWidth / 2,
                        length: distance - offsetSize,
                    }
                    sideCrossBracingHorizonTruss.push(tempHorizonTrussInfoObj)
                    
                }
                for(let k = sideBracingHeightVal; k < horizonTrussCount - 1; k++) {
                    pos_y = horizonTrussDistance * k + 0.25;
                    const tempSlopeTrussInfoObj = {
                        pos_Z: pos_Z,
                        pos_y: pos_y - railWidth / 2,
                        length: slopeTrussLength - offsetSize,
                        rotationX : -(Math.PI / 2 - slopeTrussAngle)
                    }
                    sideCrossBracingSlopeTruss.push(tempSlopeTrussInfoObj)
                }
            }
        }

        return {
            sideCrossBracingHorizonTruss,
            sideCrossBracingSlopeTruss
        };
    }, [sideBracingType, sideBracingHeightVal, params.p_d, params.leanF_p_h, params.leanF_p_d, params.b_l_t_r_pF, real_distance,trussType, roofRailDistanceY])
    
    /************** cutting hole using CSG ***************/        
    const frontBackPillarRailDataArr = useMemo(() => {
        let dataInfoArray = []
        let endCrossBracingLegs = []
        let endCrossBracingHorizonTruss = []
        let endCrossBracingSlopeTruss = []
        let count, distance = 0;
        let horizonTrussCount = 0
        
        const initDistance = legDistance;
        const tempCount = Math.floor(params.leanF_p_w / initDistance);
        if (params.leanF_p_w === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (params.leanF_p_w - tempCount * initDistance <= initDistance / 2) {
            count = tempCount;
            distance = params.leanF_p_w / count;
        } else {
            count = tempCount + 1;
            distance = params.leanF_p_w / count;
        }
        
        const endRailHeightForBracing = (endBracingType == "invert_v_bracings" || endBracingType == "v_bracings") ? 0 : pillarHeight;
        const horizonTrussDistance = (distance / 2) / 4 * 5;
        const tempHorizonTrussCount = Math.floor(params.leanF_p_h / horizonTrussDistance)
        // const slopeTrussAngle = Math.atan((distance / 2) / (horizonTrussDistance + railHeight))
        // const slopeTrussLength = Math.sqrt(Math.pow(horizonTrussDistance, 2) + Math.pow((distance / 2 - railHeight), 2))

        const endSlopeTrussAngle = Math.atan((distance / endBracingDivider) / (horizonTrussDistance + pillarHeight))
        const endSlopeTrussLength = Math.sqrt(Math.pow(horizonTrussDistance, 2) + Math.pow((distance / endBracingDivider - endRailHeightForBracing), 2))


        if (params.leanF_p_h > horizonTrussDistance * tempHorizonTrussCount) {
            horizonTrussCount = tempHorizonTrussCount + 1;
        } else {
            horizonTrussCount = tempHorizonTrussCount;
        }
        
        for (let i = 1; i < count; i++) {
            const pos_x = distance * i - params.leanF_p_w / 2;
            let shortLength = 0;
            let longLength = 0;
            let length = 0;
            let asyncLength = 0;

            const defaultLength = params.leanF_p_h + (params.leanF_p_w / 2 - Math.abs(pos_x)) * (params.b_l_t_r_pF / 12);
            if (trussType === "" || trussType === "standard") {
                shortLength = defaultLength;
                longLength = defaultLength;
            } else {
                if (params.trussType === "HSST"){
                    shortLength = defaultLength - roofRailDistanceY; 
                    longLength =  params.leanF_p_h + (params.leanF_p_w / 2.8 ) * (params.b_l_t_r_pF / 12) - roofRailDistanceY;
                }else{
                    shortLength = defaultLength - roofRailDistanceY;
                    longLength =  params.leanF_p_h + params.leanF_p_w / 2 * (1 - hangRailDivision) * params.b_l_t_r_pF / 12 - roofRailDistanceY;
                }
            }
            
            if (params.leanF_p_w > 24 || params.trussType === "HSST") {
                if (params.trussType === "HSST"){
                    length = Math.abs(pos_x) > params.leanF_p_w / 4 * hangRailDivision ? shortLength : longLength;
                }else{
                    length = Math.abs(pos_x) > params.leanF_p_w / 2 * hangRailDivision ? shortLength : longLength;
                }
            } else {
                length = params.leanF_p_h + (params.leanF_p_w / 2 - Math.abs(pos_x)) * (params.b_l_t_r_pF / 12);
            }
            asyncLength = params.leanF_p_h + (params.leanF_p_w / 2 - Math.abs(pos_x)) * (params.b_l_t_r_pF / 12);
            
            const tempInfoObj ={
                pos_x: pos_x,
                length: length - railHeight / 2 + roofRegularOffsetHeight,
                asyncLength: asyncLength - railWidth / 2 + roofRegularOffsetHeight,
            }
            
            dataInfoArray.push(tempInfoObj);
        }
    
        
        // front end cross bracing legs and horizon, slope truss
        
        for(let i = 0; i < 2; i++) {
            let pos_x;
            
            const length = params.leanF_p_h + (distance / 2) * (params.b_l_t_r_pF / 12) - railHeight / 2 + roofRegularOffsetHeight;
            if(i === 0) {
                pos_x = -params.leanF_p_w / 2 + distance / 2
                for(let j = 0; j < horizonTrussCount; j++) {
                    let pos_y;
                    pos_y = horizonTrussDistance * j
                    const tempHorizonTrussInfoObj = {
                        pos_x: pos_x,
                        pos_y: pos_y + railWidth / 2,
                        length: distance / 2 - railWidth / 2
                    }
                    endCrossBracingHorizonTruss.push(tempHorizonTrussInfoObj)
                }
                for(let k = endBracingHeightVal; k < horizonTrussCount - 1; k++) {
                    let pos_y;
                    pos_y = horizonTrussDistance * k + 0.1
                    const tempSlopeTrussInfoObj = {
                        pos_x: pos_x,
                        pos_y: pos_y,
                        length: endSlopeTrussLength,
                        rotationZ : endSlopeTrussAngle
                    }
                    endCrossBracingSlopeTruss.push(tempSlopeTrussInfoObj)
                }
            } else {
                let pos_y;
                pos_x = params.leanF_p_w / 2 - distance / 2

                for(let j = 0; j < horizonTrussCount; j++) {
                    pos_y = horizonTrussDistance * j
                    const tempHorizonTrussInfoObj = {
                        pos_x: pos_x + distance / 2 - railWidth / 2,
                        pos_y: pos_y + railWidth / 2,
                        length: distance / 2 - railWidth / 2
                    }
                    endCrossBracingHorizonTruss.push(tempHorizonTrussInfoObj)
                    
                }
                for(let k = endBracingHeightVal; k < horizonTrussCount - 1; k++) {
                    pos_y = horizonTrussDistance * k + 0.1
                    const tempSlopeTrussInfoObj = {
                        pos_x: pos_x,
                        pos_y: pos_y,
                        length: endSlopeTrussLength,
                        rotationZ : -endSlopeTrussAngle
                    }
                    endCrossBracingSlopeTruss.push(tempSlopeTrussInfoObj)
                }
            }

            const tempLegInfoObj ={
                pos_x: pos_x,
                length: length
            }
            
            
            endCrossBracingLegs.push(tempLegInfoObj)
        }

        return {
            dataInfoArray,
            endCrossBracingLegs,
            endCrossBracingHorizonTruss,
            endCrossBracingSlopeTruss
        };
    }, [params.leanF_p_w, params.leanF_p_h, params.b_l_t_r_pF, params.trussType, roofRailDistanceY, hangRailDivision, endBracingType,roofRegularOffsetHeight]);
        
    const CSGFrontBackPillarRailModelArr = useMemo(() => {
        let frontModelArr = [];
        let backModelArr = [];
        let frontEndCrossBracingLegsArr = [];
        let frontEndCrossBracingHorizonTrussArr = [];
        let frontEndCrossBracingSlopeTrussArr = [];
        let backEndCrossBracingLegsArr = []
        let backEndCrossBracingHorizonTrussArr = [];
        let backEndCrossBracingSlopeTrussArr = []

        let baseCutModelForBraceFinal = baseCutModelForBraceMesh.clone()
        baseCutModelForBraceFinal.position.set(0,-params.p_h/2 + pillarHeight, -params.leanF_p_d/ 2);
        baseCutModelForBraceFinal.updateMatrixWorld();
        const baseCutModelForBrace = CSG.fromMesh(baseCutModelForBraceFinal);

        let roofCutMdelForBraceFinal = roofCutMdelForBraceMesh.clone()
        roofCutMdelForBraceFinal.position.set(0,0,-params.leanF_p_d/2)
        roofCutMdelForBraceFinal.updateMatrixWorld();
        const roofCutModelForBrace = CSG.fromMesh(roofCutMdelForBraceFinal);
        
        const modelShape = railModel(railWidth, railHeight);
        frontBackPillarRailDataArr.dataInfoArray.forEach((item) => {    
            const meshFrontPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(hiddenBaseRailIdArr.includes(pillarRailDataArr.length - 1) ? item.asyncLength :  item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )            
            const meshBackPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(hiddenBaseRailIdArr.includes(0) ? item.asyncLength :  item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

            let meshFrontPillarRailModel_Temp = meshFrontPillarRailModel.clone();    
            meshFrontPillarRailModel_Temp.position.set(item.pos_x, 0, 0);
            meshFrontPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshFrontPillarRailModel_Temp.updateMatrix();
            meshFrontPillarRailModel_Temp.updateMatrixWorld();
            const meshFrontPillarRailModel_CSG = CSG.fromMesh(meshFrontPillarRailModel_Temp);

            let meshBackPillarRailModel_Temp = meshBackPillarRailModel.clone();    
            meshBackPillarRailModel_Temp.position.set(item.pos_x, 0, 0);
            meshBackPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshBackPillarRailModel_Temp.updateMatrix();
            meshBackPillarRailModel_Temp.updateMatrixWorld();
            const meshBackPillarRailModel_CSG = CSG.fromMesh(meshBackPillarRailModel_Temp);

            const frontPillarRailModel_CSG = meshFrontPillarRailModel_CSG.subtract(meshDelModel_CSG.gableFrontLeanFront);
            const backPillarRailModel_CSG = meshBackPillarRailModel_CSG.subtract(meshDelModel_CSG.gableFrontLeanBack);

            const CSGFrontPillarRailModel = CSG.toMesh(
                frontPillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGBackPillarRailModel = CSG.toMesh(
                backPillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
        
            frontModelArr.push(CSGFrontPillarRailModel);
            backModelArr.push(CSGBackPillarRailModel);
        })

        frontBackPillarRailDataArr.endCrossBracingLegs.forEach((item) => {    

            let dynamicHeight = item.length

            const meshPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(dynamicHeight)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
        
            let meshFrontEndCrossBracingLegs = meshPillarRailModel.clone();    
            meshFrontEndCrossBracingLegs.position.set(item.pos_x, 0, 0);
            meshFrontEndCrossBracingLegs.rotateX(-Math.PI / 2);
            meshFrontEndCrossBracingLegs.updateMatrix();
            meshFrontEndCrossBracingLegs.updateMatrixWorld();
            const meshFrontEndCrossBracingLegs_CSG = CSG.fromMesh(meshFrontEndCrossBracingLegs);
            const meshBackEndCrossBracingLegs_CSG = CSG.fromMesh(meshFrontEndCrossBracingLegs);

            const frontEndCrossBracingLegs_CSG = meshFrontEndCrossBracingLegs_CSG.subtract(meshDelModel_CSG.gableFrontLeanFront);
            const backEndCrossBracingLegs_CSG = meshBackEndCrossBracingLegs_CSG.subtract(meshDelModel_CSG.gableFrontLeanBack);
            
            const CSGFrontEndCrossBracingLegs = CSG.toMesh(
                frontEndCrossBracingLegs_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGBackEndCrossBracingLegs = CSG.toMesh(
                backEndCrossBracingLegs_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
        
            frontEndCrossBracingLegsArr.push(CSGFrontEndCrossBracingLegs);
            backEndCrossBracingLegsArr.push(CSGBackEndCrossBracingLegs);
        })

        frontBackPillarRailDataArr.endCrossBracingHorizonTruss.forEach((item) => {    
            const meshPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
        
            let meshFrontEndCrossBracingHorizonTruss = meshPillarRailModel.clone();    
            meshFrontEndCrossBracingHorizonTruss.position.set(item.pos_x, item.pos_y, 0);
            meshFrontEndCrossBracingHorizonTruss.rotateY(-Math.PI / 2);
            meshFrontEndCrossBracingHorizonTruss.rotateZ(Math.PI / 2);
            meshFrontEndCrossBracingHorizonTruss.updateMatrix();
            meshFrontEndCrossBracingHorizonTruss.updateMatrixWorld();
            const meshFrontEndCrossBracingHorizonTruss_CSG = CSG.fromMesh(meshFrontEndCrossBracingHorizonTruss);
            const meshBackEndCrossBracingHorizonTruss_CSG = CSG.fromMesh(meshFrontEndCrossBracingHorizonTruss);

            const frontEndCrossBracingHorizonTruss_CSG = meshFrontEndCrossBracingHorizonTruss_CSG.subtract(meshDelModel_CSG.gableFrontLeanFront);
            const backEndCrossBracingHorizonTruss_CSG = meshBackEndCrossBracingHorizonTruss_CSG.subtract(meshDelModel_CSG.gableFrontLeanBack);

            const CSGFrontEndCrossBracingHorizonTruss = CSG.toMesh(
                frontEndCrossBracingHorizonTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGBackEndCrossBracingHorizonTruss = CSG.toMesh(
                backEndCrossBracingHorizonTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
        
            frontEndCrossBracingHorizonTrussArr.push(CSGFrontEndCrossBracingHorizonTruss);
            backEndCrossBracingHorizonTrussArr.push(CSGBackEndCrossBracingHorizonTruss);
        })

        let distanceValue = 0;
        frontBackPillarRailDataArr.endCrossBracingSlopeTruss.forEach((item, index, object) => {   
            let widthDistance = (endBracingType == "v_bracings") ? item.pos_x + (((params.leanF_p_w/2) - Math.abs(item.pos_x) - railWidth) * Math.sign(item.pos_x))/2 : item.pos_x;
            let sign = (endBracingType == "v_bracings") ? -1  : 1;
            const meshPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
        
            let meshFrontEndCrossBracingSlopeTruss = meshPillarRailModel.clone();    
            meshFrontEndCrossBracingSlopeTruss.position.set(widthDistance, item.pos_y, 0);
            meshFrontEndCrossBracingSlopeTruss.rotateX(-Math.PI / 2);
            meshFrontEndCrossBracingSlopeTruss.rotateY(-item.rotationZ * sign);

            meshFrontEndCrossBracingSlopeTruss.updateMatrix();
            meshFrontEndCrossBracingSlopeTruss.updateMatrixWorld();
            const meshFrontEndCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshFrontEndCrossBracingSlopeTruss);
            const meshBackEndCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshFrontEndCrossBracingSlopeTruss);

            const frontEndCrossBracingSlopeTruss_CSGFinalRoof = meshFrontEndCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
            const frontEndCrossBracingSlopeTruss_CSGFinal = frontEndCrossBracingSlopeTruss_CSGFinalRoof.subtract(baseCutModelForBrace);
            const frontEndCrossBracingSlopeTruss_CSG = frontEndCrossBracingSlopeTruss_CSGFinal.subtract(meshDelModel_CSG.gableFrontLeanFront);

            const backEndCrossBracingSlopeTruss_CSGRoof = meshBackEndCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
            const backEndCrossBracingSlopeTruss_CSGFinal = backEndCrossBracingSlopeTruss_CSGRoof.subtract(baseCutModelForBrace);
            const backEndCrossBracingSlopeTruss_CSG = backEndCrossBracingSlopeTruss_CSGFinal.subtract(meshDelModel_CSG.gableFrontLeanBack);        
            

            const CSGFrontEndCrossBracingSlopeTruss = CSG.toMesh(
                frontEndCrossBracingSlopeTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGBackEndCrossBracingSlopeTruss = CSG.toMesh(
                backEndCrossBracingSlopeTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )

            
            if(endBracingType == "x_bracings" || endBracingType == "invert_v_bracings" || endBracingType == "v_bracings" || endBracingType == "k_bay_bracings"){
                let meshFrontXEndCrossBracingSlopeTruss = meshPillarRailModel.clone();    
                if(endBracingType == "v_bracings"){

                    meshFrontXEndCrossBracingSlopeTruss.position.set(item.pos_x + (((params.leanF_p_w/2) - Math.abs(item.pos_x) - railWidth) * Math.sign(item.pos_x))/2, item.pos_y + pillarHeight/2, 0);
                    meshFrontXEndCrossBracingSlopeTruss.rotateX(-Math.PI / 2);
                    meshFrontXEndCrossBracingSlopeTruss.rotateY(-item.rotationZ);

                }else{
                    meshFrontXEndCrossBracingSlopeTruss.position.set(item.pos_x + (((params.leanF_p_w/2) - Math.abs(item.pos_x) - railWidth) * Math.sign(item.pos_x)), item.pos_y, 0);
                    meshFrontXEndCrossBracingSlopeTruss.rotateX(-Math.PI / 2);
                    meshFrontXEndCrossBracingSlopeTruss.rotateY(item.rotationZ);
                }

                meshFrontXEndCrossBracingSlopeTruss.updateMatrix();
                meshFrontXEndCrossBracingSlopeTruss.updateMatrixWorld();
                const meshFrontEndXCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshFrontXEndCrossBracingSlopeTruss);
                const meshBackEndXCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshFrontXEndCrossBracingSlopeTruss);

                const frontXEndCrossBracingSlopeTruss_CSGFinalRoof = meshFrontEndXCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
                const frontXEndCrossBracingSlopeTruss_CSGFinal = frontXEndCrossBracingSlopeTruss_CSGFinalRoof.subtract(baseCutModelForBrace);
                const frontXEndCrossBracingSlopeTruss_CSG = frontXEndCrossBracingSlopeTruss_CSGFinal.subtract(meshDelModel_CSG.gableFrontLeanFront);

                const backXEndCrossBracingSlopeTruss_CSGRoof = meshBackEndXCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
                const backXEndCrossBracingSlopeTruss_CSGFinal = backXEndCrossBracingSlopeTruss_CSGRoof.subtract(baseCutModelForBrace);
                const backXEndCrossBracingSlopeTruss_CSG = backXEndCrossBracingSlopeTruss_CSGFinal.subtract(meshDelModel_CSG.gableFrontLeanBack);

                const CSGFrontXEndCrossBracingSlopeTruss = CSG.toMesh(
                    frontXEndCrossBracingSlopeTruss_CSG,   
                    new THREE.Matrix4(),
                    new THREE.MeshStandardMaterial({ color: 'blue' })
                )
                const CSGBackXEndCrossBracingSlopeTruss = CSG.toMesh(
                    backXEndCrossBracingSlopeTruss_CSG,
                    new THREE.Matrix4(),
                    new THREE.MeshStandardMaterial({ color: 'blue' })
                )
                
                if((params.singleSlope && Math.sign(item.pos_x) == -1 && (item.pos_y + distanceValue) < params.lean_p_h - ((params.lean_p_w) * (params.b_l_t_r_p/12))) || (!params.singleSlope) || (Math.sign(item.pos_z) == 1)){
                    frontEndCrossBracingSlopeTrussArr.push(CSGFrontXEndCrossBracingSlopeTruss);
                    backEndCrossBracingSlopeTrussArr.push(CSGBackXEndCrossBracingSlopeTruss);
                }
            }

            if(index === 1) distanceValue = item.pos_y - object[0].pos_y
    
            if((params.singleSlope && Math.sign(item.pos_x) === -1 && (item.pos_y + distanceValue) < params.p_h - ((params.p_w) * (params.p_r_p/12))) || (!params.singleSlope) || (Math.sign(item.pos_x) === 1)) frontEndCrossBracingSlopeTrussArr.push(CSGFrontEndCrossBracingSlopeTruss);
            if((params.singleSlope && Math.sign(item.pos_x) === -1 && (item.pos_y + distanceValue) < params.p_h - ((params.p_w) * (params.p_r_p/12))) || (!params.singleSlope) || (Math.sign(item.pos_x) === 1)) backEndCrossBracingSlopeTrussArr.push(CSGBackEndCrossBracingSlopeTruss);
        })

             
        
        return { frontModelArr, frontEndCrossBracingLegsArr, frontEndCrossBracingHorizonTrussArr, frontEndCrossBracingSlopeTrussArr, backEndCrossBracingLegsArr, backEndCrossBracingHorizonTrussArr, backEndCrossBracingSlopeTrussArr, backModelArr };
    }, [roofCutMdelForBraceMesh, baseCutModelForBraceMesh, frontBackPillarRailDataArr, hiddenBaseRailIdArr, params.add_storage_front, legDistance, legDistanceNew, params.leanF_p_d, meshDelModel_CSG.gableFrontLeanBack, meshDelModel_CSG.gableFrontLeanFront, meshDelModel_CSG.gableFrontLeanStorageFront, params.b_l_t_r_pF, params.leanF_p_w, params.leanF_p_h])
    
    const CSGSideRailGroupModelArr = useMemo(() => {
        let leftModelArr = [];
        let rightModelArr = [];
        let leftSideCrossBracingHorizonTrussArr = [];
        let rightSideCrossBracingHorizonTrussArr = [];
        let leftSideCrossBracingSlopeTrussArr = [];
        let rightSideCrossBracingSlopeTrussArr = [];



        const dynamicHeight = params.p_r_s === 1 ? params.leanF_p_h : params.leanF_p_h - params.b_l_t_r_pF / 12 * railHeight;
        const innerLegLength = dynamicHeight + outInDistance * params.b_l_t_r_pF / 12 + (params.p_r_s === 1 && (const_var.legstype === "ladder" || const_var.legstype === "zigzag") && (const_var.roofRegularDst * 2 - 0.1));
        
        let baseCutModelForBraceFinal = baseCutModelForBraceMesh.clone()
        baseCutModelForBraceFinal.position.set(0,-params.p_h/2,params.p_d/2)
        baseCutModelForBraceFinal.updateMatrixWorld();
        const baseCutModelForBrace = CSG.fromMesh(baseCutModelForBraceFinal);

        let roofCutMdelForBraceFinal = roofCutMdelForBraceMesh.clone()
        roofCutMdelForBraceFinal.position.set(params.leanF_p_w/2, 0 , params.p_d/2)
        roofCutMdelForBraceFinal.updateMatrixWorld();
        const roofCutModelForBrace = CSG.fromMesh(roofCutMdelForBraceFinal);

        const modelShape = railModel(railHeight, railWidth);
        pillarRailDataArr.forEach((pos_z, index) => {    
            const meshOuterPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(dynamicHeight )),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

            const meshInnerPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(innerLegLength)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

            //--- left -- outer
            let meshLeftOuterPillarRailModel_Temp = meshOuterPillarRailModel.clone();    
            meshLeftOuterPillarRailModel_Temp.position.set(0.005, 0, pos_z);
            meshLeftOuterPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshLeftOuterPillarRailModel_Temp.updateMatrix();
            meshLeftOuterPillarRailModel_Temp.updateMatrixWorld();
            const meshLeftOuterPillarRailModel_CSG = CSG.fromMesh(meshLeftOuterPillarRailModel_Temp);

            const leftOuterPillarRailModel_CSG = meshLeftOuterPillarRailModel_CSG.subtract(meshDelModel_CSG.gableFrontLeanLeft);
            const CSGLeftOuterPillarRailModel = CSG.toMesh(
                leftOuterPillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )

            //--- left -- inner
            let meshLeftInnerPillarRailModel_Temp = meshInnerPillarRailModel.clone();    
            meshLeftInnerPillarRailModel_Temp.position.set(0.005, 0, pos_z);
            meshLeftInnerPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshLeftInnerPillarRailModel_Temp.updateMatrix();
            meshLeftInnerPillarRailModel_Temp.updateMatrixWorld();
            const meshLeftInnerPillarRailModel_CSG = CSG.fromMesh(meshLeftInnerPillarRailModel_Temp);

            const leftInnerPillarRailModel_CSG = meshLeftInnerPillarRailModel_CSG.subtract(meshDelModel_CSG.gableFrontLeanLeft);
            const CSGLeftInnerPillarRailModel = CSG.toMesh(
                leftInnerPillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )

            //--- right -- outer
            let meshRightOuterPillarRailModel_Temp = meshOuterPillarRailModel.clone();    
            meshRightOuterPillarRailModel_Temp.position.set(-0.005, 0, pos_z);
            meshRightOuterPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshRightOuterPillarRailModel_Temp.updateMatrix();
            meshRightOuterPillarRailModel_Temp.updateMatrixWorld();
            const meshRightOuterPillarRailModel_CSG = CSG.fromMesh(meshRightOuterPillarRailModel_Temp);

            const rightOuterPillarRailModel_CSG = meshRightOuterPillarRailModel_CSG.subtract(meshDelModel_CSG.gableFrontLeanRight);
            const CSGRightOuterPillarRailModel = CSG.toMesh(
                rightOuterPillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )

            //--- right -- inner
            let meshRightInnerPillarRailModel_Temp = meshInnerPillarRailModel.clone();    
            meshRightInnerPillarRailModel_Temp.position.set(-0.005, 0, pos_z);
            meshRightInnerPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshRightInnerPillarRailModel_Temp.updateMatrix();
            meshRightInnerPillarRailModel_Temp.updateMatrixWorld();
            const meshRightInnerPillarRailModel_CSG = CSG.fromMesh(meshRightInnerPillarRailModel_Temp);

            const rightInnerPillarRailModel_CSG = meshRightInnerPillarRailModel_CSG.subtract(meshDelModel_CSG.gableFrontLeanRight);
            const CSGRightInnerPillarRailModel = CSG.toMesh(
                rightInnerPillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
        
            leftModelArr.push({
                outer: CSGLeftOuterPillarRailModel,
                inner: CSGLeftInnerPillarRailModel
            });
            rightModelArr.push({
                outer: CSGRightOuterPillarRailModel,
                inner: CSGRightInnerPillarRailModel
            });
        })

        sidePillarRailDataArr.sideCrossBracingHorizonTruss.map((item) => {    
            const meshPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(item.length - 0.1)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
        
            let meshLeftSideCrossBracingHorizonTruss = meshPillarRailModel.clone();    
            meshLeftSideCrossBracingHorizonTruss.position.set(-0.05, item.pos_y, item.pos_Z);
            meshLeftSideCrossBracingHorizonTruss.rotateZ(Math.PI / 2);
            meshLeftSideCrossBracingHorizonTruss.updateMatrix();
            meshLeftSideCrossBracingHorizonTruss.updateMatrixWorld();
            const meshLeftSideCrossBracingHorizonTruss_CSG = CSG.fromMesh(meshLeftSideCrossBracingHorizonTruss);
            const meshRightSideCrossBracingHorizonTruss_CSG = CSG.fromMesh(meshLeftSideCrossBracingHorizonTruss);

            const leftSideCrossBracingHorizonTruss_CSG = meshLeftSideCrossBracingHorizonTruss_CSG.subtract(meshDelModel_CSG.gableFrontLeanLeft);
            const rightSideCrossBracingHorizonTruss_CSG = meshRightSideCrossBracingHorizonTruss_CSG.subtract(meshDelModel_CSG.gableFrontLeanRight);

            const CSGLeftSideCrossBracingHorizonTruss = CSG.toMesh(
                leftSideCrossBracingHorizonTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGRightSIdeCrossBracingHorizonTruss = CSG.toMesh(
                rightSideCrossBracingHorizonTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
        
            leftSideCrossBracingHorizonTrussArr.push(CSGLeftSideCrossBracingHorizonTruss);
            rightSideCrossBracingHorizonTrussArr.push(CSGRightSIdeCrossBracingHorizonTruss);

            return null;
        })

        let distanceValue = 0;
        sidePillarRailDataArr.sideCrossBracingSlopeTruss.map((item, index, object) => {  
            const leanCenter = (params.p_d/2 + (params.leanF_p_d)/2 + ((legCount-1) == 1 && 0.21));
            const dFromCenter = ((legCount-1) == 1) ? -((item.pos_Z) - leanCenter) : ((item.pos_Z) - leanCenter);
            const sign = Math.sign(dFromCenter)
            const railW = (sign == 1) ? railHeight : 0
            
            const meshPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(item.length - 0.1)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
        
            let meshLeftSideCrossBracingSlopeTruss = meshPillarRailModel.clone();    
            meshLeftSideCrossBracingSlopeTruss.position.set(-0.05, item.pos_y, item.pos_Z + (sideBracingType == "v_bracings" && (((real_distance - railW) * sign) / 2)) + 0.025);
            meshLeftSideCrossBracingSlopeTruss.rotateX(item.rotationX);
            meshLeftSideCrossBracingSlopeTruss.rotateZ(Math.PI / 2);
            meshLeftSideCrossBracingSlopeTruss.updateMatrix();
            meshLeftSideCrossBracingSlopeTruss.updateMatrixWorld();
            const meshLeftSideCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshLeftSideCrossBracingSlopeTruss);
            const meshRightSideCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshLeftSideCrossBracingSlopeTruss);

            const leftSideCrossBracingSlopeTruss_CSGFinalRoof = meshLeftSideCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
            const leftSideCrossBracingSlopeTruss_CSGFinal = leftSideCrossBracingSlopeTruss_CSGFinalRoof.subtract(baseCutModelForBrace);
            const leftSideCrossBracingSlopeTruss_CSG = leftSideCrossBracingSlopeTruss_CSGFinal.subtract(meshDelModel_CSG.gableFrontLeanLeft);

            const rightSideCrossBracingSlopeTruss_CSGFinalroof = meshRightSideCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
            const rightSideCrossBracingSlopeTruss_CSGFinal = rightSideCrossBracingSlopeTruss_CSGFinalroof.subtract(baseCutModelForBrace);
            const rightSideCrossBracingSlopeTruss_CSG = rightSideCrossBracingSlopeTruss_CSGFinal.subtract(meshDelModel_CSG.gableFrontLeanRight);

            const CSGLeftSideCrossBracingSlopeTruss = CSG.toMesh(
                leftSideCrossBracingSlopeTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGRightSIdeCrossBracingSlopeTruss = CSG.toMesh(
                rightSideCrossBracingSlopeTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )

            if(sideBracingType == "x_bracings" || sideBracingType == "invert_v_bracings" || sideBracingType == "v_bracings" || sideBracingType == "k_bay_bracings"){
                let meshLeftXEndCrossBracingSlopeTruss = meshPillarRailModel.clone();    
                if(sideBracingType == "v_bracings"){
                    meshLeftXEndCrossBracingSlopeTruss.position.set(-0.05, item.pos_y, item.pos_Z + ((real_distance - railW) * sign) / 2 -0.05);
                    meshLeftXEndCrossBracingSlopeTruss.rotateX(-item.rotationX - Math.PI);
                    meshLeftXEndCrossBracingSlopeTruss.rotateZ(Math.PI / 2);
                }else{
                    meshLeftXEndCrossBracingSlopeTruss.position.set(-0.05, item.pos_y, item.pos_Z + ((real_distance - railW) * sign) -0.05);
                    meshLeftXEndCrossBracingSlopeTruss.rotateX(-item.rotationX - Math.PI);
                    meshLeftXEndCrossBracingSlopeTruss.rotateZ(Math.PI / 2);
                }
                meshLeftXEndCrossBracingSlopeTruss.updateMatrix();
                meshLeftXEndCrossBracingSlopeTruss.updateMatrixWorld();

                meshLeftXEndCrossBracingSlopeTruss.updateMatrix();
                meshLeftXEndCrossBracingSlopeTruss.updateMatrixWorld();
                const meshLeftEndXCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshLeftXEndCrossBracingSlopeTruss);
                const meshRightEndXCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshLeftXEndCrossBracingSlopeTruss);

                const leftXEndCrossBracingSlopeTruss_CSGRoof = meshLeftEndXCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
                const leftXEndCrossBracingSlopeTruss_CSGFinal = leftXEndCrossBracingSlopeTruss_CSGRoof.subtract(baseCutModelForBrace);
                const leftXEndCrossBracingSlopeTruss_CSG = leftXEndCrossBracingSlopeTruss_CSGFinal.subtract(meshDelModel_CSG.gableFrontLeanLeft);

                const rightXEndCrossBracingSlopeTruss_CSGRoof = meshRightEndXCrossBracingSlopeTruss_CSG.subtract(roofCutModelForBrace);
                const rightXEndCrossBracingSlopeTruss_CSGFinal = rightXEndCrossBracingSlopeTruss_CSGRoof.subtract(baseCutModelForBrace);
                const rightXEndCrossBracingSlopeTruss_CSG = rightXEndCrossBracingSlopeTruss_CSGFinal.subtract(meshDelModel_CSG.gableFrontLeanRight);

                const CSGLeftXEndCrossBracingSlopeTruss = CSG.toMesh(
                    leftXEndCrossBracingSlopeTruss_CSG,
                    new THREE.Matrix4(),
                    new THREE.MeshStandardMaterial({ color: 'blue' })
                )
                const CSGRightXEndCrossBracingSlopeTruss = CSG.toMesh(
                    rightXEndCrossBracingSlopeTruss_CSG,
                    new THREE.Matrix4(),
                    new THREE.MeshStandardMaterial({ color: 'blue' })
                )

                if(index == 1) distanceValue = item.pos_y - object[0].pos_y
                if((params.singleSlope && item.pos_y + distanceValue <= params.p_h - (params.p_w * (params.p_r_p/12))) || (!params.singleSlope)) {
                    leftSideCrossBracingSlopeTrussArr.push(CSGLeftXEndCrossBracingSlopeTruss);
                    rightSideCrossBracingSlopeTrussArr.push(CSGRightXEndCrossBracingSlopeTruss);
                }
            }            
        
            leftSideCrossBracingSlopeTrussArr.push(CSGLeftSideCrossBracingSlopeTruss);
            rightSideCrossBracingSlopeTrussArr.push(CSGRightSIdeCrossBracingSlopeTruss);

            return null;
        })

        return {
            dynamicHeight,
            innerLegLength,
            
            leftModelArr,
            rightModelArr,
            
            leftSideCrossBracingHorizonTrussArr,
            rightSideCrossBracingHorizonTrussArr,
            leftSideCrossBracingSlopeTrussArr,
            rightSideCrossBracingSlopeTrussArr
        };
    }, [params.leanF_p_h, meshDelModel_CSG.gableFrontLeanLeft, meshDelModel_CSG.gableFrontLeanRight, pillarRailDataArr, sidePillarRailDataArr, meshDelModel_CSG.leftStorageFront, meshDelModel_CSG.rightStorageFront, params.b_l_t_r_pF, params.leanF_p_w, params.p_r_s, outInDistance, const_var.legstype,real_distance])
    
    const CSGFrontBackBottomRailData = useMemo(() => {
        const modelShape = railModel(railHeight, railWidth);

        const meshBottomRailModel = new THREE.Mesh(
            new THREE.ExtrudeGeometry(modelShape, extrudeSettings(params.leanF_p_w - 2 * railWidth)),
            new THREE.MeshStandardMaterial({ color: 'pink' })
        )
        
        let meshFrontBottomRailModel_Temp = meshBottomRailModel.clone();    
        meshFrontBottomRailModel_Temp.position.set(-params.leanF_p_w / 2 + railWidth, railWidth / 2, 0);
        meshFrontBottomRailModel_Temp.rotateY(Math.PI / 2);
        meshFrontBottomRailModel_Temp.updateMatrix();
        meshFrontBottomRailModel_Temp.updateMatrixWorld();
        const meshFrontBottomRailModel_CSG = CSG.fromMesh(meshFrontBottomRailModel_Temp);

        let meshBackBottomRailModel_Temp = meshBottomRailModel.clone();    
        meshBackBottomRailModel_Temp.position.set(-params.leanF_p_w / 2 + railWidth, railWidth / 2, 0);
        meshBackBottomRailModel_Temp.rotateY(Math.PI / 2);
        meshBackBottomRailModel_Temp.updateMatrix();
        meshBackBottomRailModel_Temp.updateMatrixWorld();
        const meshBackBottomRailModel_CSG = CSG.fromMesh(meshBackBottomRailModel_Temp);

        const frontBottomRailModel_CSG = meshFrontBottomRailModel_CSG.subtract(meshDelModel_CSG.gableFrontLeanFront);
        const backBottomRailModel_CSG = meshBackBottomRailModel_CSG.subtract(meshDelModel_CSG.gableFrontLeanBack);

        const CSGFrontBottomRailModel = CSG.toMesh(
            frontBottomRailModel_CSG,
            new THREE.Matrix4(),
            new THREE.MeshStandardMaterial({ color: 'blue' })
        )

        const CSGBackBottomRailModel = CSG.toMesh(
            backBottomRailModel_CSG,
            new THREE.Matrix4(),
            new THREE.MeshStandardMaterial({ color: 'blue' })
        )

        return { CSGFrontBottomRailModel, CSGBackBottomRailModel};
    }, [params.leanF_p_w, meshDelModel_CSG, frontBackPillarRailDataArr])

    //----- loft piece rail-----
    useMemo(() => {
        const instancedLoftPieceRail = [];

        new Array(2).fill('').forEach((_, index_dir) => {
            let offsetForDir = 1;
            if (index_dir === 0) offsetForDir = 1;
            else offsetForDir = -1;

            new Array(pillarRailDataArr.length).fill('').forEach((_, index_truss) => {
                obj_loftPieceRail.position.set(-offsetForDir * (params.leanF_p_w / 2 - 0.05), params.leanF_p_h - 0.05, params.p_d / 2 + pillarRailDataArr[index_truss].pos_z - pillarWidth / 2 * offsetForDir);
                if (offsetForDir === 1) obj_loftPieceRail.rotation.y = 0;
                else obj_loftPieceRail.rotation.y = Math.PI;

                if (params.singleSlope) obj_loftPieceRail.scale.setScalar(0);
                else obj_loftPieceRail.scale.setScalar(1);

                obj_loftPieceRail.updateMatrix();
                instancedLoftPieceRail.push(...obj_loftPieceRail.matrix.elements);
            })
        })
        
        setLoftPieceRail(new THREE.InstancedBufferAttribute(new Float32Array(instancedLoftPieceRail), 16));
    }, [params.p_d, params.leanF_p_w, params.leanF_p_h, params.leanF_p_d, pillarRailDataArr])
    
    return (
        <group name='gable_leanto_legs'>
            {leftOuterPillar.array.length > 0 && [1].map(() =>
                <instancedMesh name='leftOuterPillar' key={leftOuterPillar.array.length} instanceMatrix={leftOuterPillar} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarHeight, pillarWidth), extrudeSettings(params.leanF_p_h)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {rightOuterPillar.array.length > 0 && [1].map(() =>
                <instancedMesh name='rightOuterPillar' key={rightOuterPillar.array.length} instanceMatrix={rightOuterPillar} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarHeight, pillarWidth), extrudeSettings(params.leanF_p_h)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {leftInnerPillar.array.length > 0 && [1].map(() =>
                <instancedMesh name='leftInnerPillar' key={leftInnerPillar.array.length} instanceMatrix={leftInnerPillar} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarHeight, pillarWidth), extrudeSettings(params.leanF_p_h + regularHeight - 0.1 + outInDistance * Math.tan(angle) - pillarWidth / 2)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {rightInnerPillar.array.length > 0 && [1].map(() =>
                <instancedMesh name='rightInnerPillar' key={rightInnerPillar.array.length} instanceMatrix={rightInnerPillar} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarHeight, pillarWidth), extrudeSettings(params.leanF_p_h + regularHeight - 0.1 + outInDistance * Math.tan(angle) - pillarWidth / 2)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {leftRoofRail.array.length > 0 && [1].map(() =>
                <instancedMesh name='leftRoofRail' key={leftRoofRail.array.length} instanceMatrix={leftRoofRail} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarWidth, pillarHeight), extrudeSettings(roofRailLength)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {rightRoofRail.array.length > 0 && [1].map(() =>
                <instancedMesh name='rightRoofRail' key={rightRoofRail.array.length} instanceMatrix={rightRoofRail} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarWidth, pillarHeight), extrudeSettings(roofRailLength)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {rungHRail.array.length > 0 && [1].map(() =>
                <instancedMesh name='rungHRail' key={rungHRail.array.length} instanceMatrix={rungHRail} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarWidth, pillarHeight), extrudeSettings(rungHRailLength)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {leftSlopeRail.array.length > 0 && [1].map(() =>
                <instancedMesh name='leftSlopeRail' key={leftSlopeRail.array.length} instanceMatrix={leftSlopeRail} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarWidth, pillarHeight), extrudeSettings(sideEdgeSlopeRailLength)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {rightSlopeRail.array.length > 0 && [1].map(() =>
                <instancedMesh name='rightSlopeRail' key={rightSlopeRail.array.length} instanceMatrix={rightSlopeRail} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarWidth, pillarHeight), extrudeSettings(sideEdgeSlopeRailLength)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {roofBaseRail.array.length > 0 && [1].map(() =>
                <instancedMesh name='roofBaseRail' key={roofBaseRail.array.length} instanceMatrix={roofBaseRail} instanceMatrix-needsUpdate={true} args={[null, null, roofBaseRailArr.length * 2]} position={[0, 0, params.p_d / 2 + pillarWidth / 2]} rotation={[0, Math.PI / 2, 0]} frustumCulled={false}>
                    <extrudeGeometry args={[roofBaseRailModel(), extrudeSettings(params.leanF_p_d - pillarWidth / 2)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {leftLadderConnectRail.array.length > 0 && [1].map(() =>
                <instancedMesh name='leftLadderConnectRail' key={leftLadderConnectRail.array.length} instanceMatrix={leftLadderConnectRail} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length * ladderConnectNumber]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarWidth, pillarHeight), extrudeSettings(outInDistance)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {rightLadderConnectRail.array.length > 0 && [1].map(() =>
                <instancedMesh name='rightLadderConnectRail' key={rightLadderConnectRail.array.length} instanceMatrix={rightLadderConnectRail} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length * ladderConnectNumber]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarWidth, pillarHeight), extrudeSettings(outInDistance)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {leftZigzagConnectRail.array.length > 0 && [1].map(() =>
                <instancedMesh name='leftZigzagConnectRail' key={leftZigzagConnectRail.array.length} instanceMatrix={leftZigzagConnectRail} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length * zigzagConnectNumber]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarHeight, pillarWidth), extrudeSettings(outInDistance / Math.sin(Math.PI / 4))]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {rightZigzagConnectRail.array.length > 0 && [1].map(() =>
                <instancedMesh name='rightZigzagConnectRail' key={rightZigzagConnectRail.array.length} instanceMatrix={rightZigzagConnectRail} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length * zigzagConnectNumber]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarHeight, pillarWidth), extrudeSettings(outInDistance / Math.sin(Math.PI / 4))]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {leftZigzagBottomRail.array.length > 0 && [1].map(() =>
                <instancedMesh name='leftZigzagBottomRail' key={leftZigzagBottomRail.array.length} instanceMatrix={leftZigzagBottomRail} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarWidth, pillarHeight), extrudeSettings(outInDistance)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            {rightZigzagBottomRail.array.length > 0 && [1].map(() =>
                <instancedMesh name='rightZigzagBottomRail' key={rightZigzagBottomRail.array.length} instanceMatrix={rightZigzagBottomRail} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length]} frustumCulled={false}>
                    <extrudeGeometry args={[railModel(pillarWidth, pillarHeight), extrudeSettings(outInDistance)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>
            )}
            
            {params.p_b_c_b_f_f === 'Close' &&
                <>
                    {CSGFrontBackPillarRailModelArr.frontModelArr.map((item, index_front) =>
                        <mesh key={`gable_front_lean_front_leg_${index_front}`} name={`gable_front_lean_front_leg_${index_front}`} geometry={item.geometry} position={[0, 0, params.p_d / 2 + params.leanF_p_d - pillarWidth / 2 - 0.05]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    <mesh name='gable_front_lean_front_leg_base_rail' geometry={CSGFrontBackBottomRailData.CSGFrontBottomRailModel.geometry} position={[0, 0, params.p_d / 2 + params.leanF_p_d - pillarWidth / 2]}>
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </mesh>
                </>
            }
            {params.p_b_c_b_f_b === 'Close' && params.p_f_w !== 'Close' &&
                <>
                    {CSGFrontBackPillarRailModelArr.backModelArr.map((item, index_front) =>
                        <mesh key={`gable_front_lean_back_leg_${index_front}`} name={`gable_front_lean_back_leg_${index_front}`} geometry={item.geometry} position={[0, 0, params.p_d / 2 + pillarWidth + 0.1]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    <mesh name='gable_front_lean_back_leg_base_raill' geometry={CSGFrontBackBottomRailData.CSGBackBottomRailModel.geometry} position={[0, 0, params.p_d / 2 + pillarWidth + 0.1]}>
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </mesh>
                </>
            }
            {params.added_building_bracing.p_e_c_b_f && 
                <>
                    {CSGFrontBackPillarRailModelArr.frontEndCrossBracingLegsArr.map((item, index_front) =>
                        <mesh key={`front-leg-rail-${index_front}`} name="gable_front_lean_front_leg_brace" geometry={item.geometry} position={[0, 0, params.p_d / 2 + params.leanF_p_d - pillarWidth / 2]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    {CSGFrontBackPillarRailModelArr.frontEndCrossBracingHorizonTrussArr.map((item, index_front_horizon) =>
                    
                        <mesh key={`front-horizon-rail-${index_front_horizon}`} name="gable_front_lean_front_leg_brace" geometry={item.geometry} position={[0, 0, params.p_d / 2 + params.leanF_p_d - pillarWidth / 2]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    {CSGFrontBackPillarRailModelArr.frontEndCrossBracingSlopeTrussArr.map((item, index_front_vertical) =>
                        <mesh key={`front-vertical-rail-${index_front_vertical}`} name="gable_front_lean_front_leg_brace" geometry={item.geometry} position={[0, 0, params.p_d / 2 + params.leanF_p_d - pillarWidth / 2]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}

                    {CSGFrontBackPillarRailModelArr.backEndCrossBracingLegsArr.map((item, index_back_leg) =>
                        <mesh key={`back-leg-rail-${index_back_leg}`} name="gable_front_lean_back_leg_brace" geometry={item.geometry} position={[0, 0, params.p_d / 2 + pillarWidth + 0.1]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    {CSGFrontBackPillarRailModelArr.backEndCrossBracingHorizonTrussArr.map((item, index_back_horizon) =>
                        <mesh key={`back-horizon-rail-${index_back_horizon}`} name="gable_front_lean_back_leg_brace" geometry={item.geometry} position={[0, 0, params.p_d / 2 + pillarWidth + 0.1]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    {CSGFrontBackPillarRailModelArr.backEndCrossBracingSlopeTrussArr.map((item, index_back_vertical) =>
                        <mesh key={`back-vertical-rail-${index_back_vertical}`} name="gable_front_lean_back_leg_brace" geometry={item.geometry} position={[0, 0, params.p_d / 2 + pillarWidth + 0.1]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                </>
            }
            {params.added_building_bracing.p_s_c_b_f && 
                <>
                    {CSGSideRailGroupModelArr.leftSideCrossBracingHorizonTrussArr.map((item, index_side_horizon) =>
                        <mesh key={`side-horizon-rail-${index_side_horizon}`} geometry={item.geometry} position={[-params.leanF_p_w / 2 + railWidth, 0, 0]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    {CSGSideRailGroupModelArr.leftSideCrossBracingSlopeTrussArr.map((item, index_side_vertical) =>
                        <mesh key={`side-vertical-rail-${index_side_vertical}`} geometry={item.geometry} position={[-params.leanF_p_w / 2 + railWidth, 0, 0]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}

                    {CSGSideRailGroupModelArr.rightSideCrossBracingHorizonTrussArr.map((item, index_side_horizon) =>
                        <mesh key={`side-horizon-rail-${index_side_horizon}`} geometry={item.geometry} position={[params.leanF_p_w / 2 - railWidth / 2, 0, 0]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                    {CSGSideRailGroupModelArr.rightSideCrossBracingSlopeTrussArr.map((item, index_side_vertical) =>
                        <mesh key={`side-vertical-rail-${index_side_vertical}`} geometry={item.geometry} position={[params.leanF_p_w / 2 - railWidth / 2, 0, 0]}>
                            <MaterialTruss normalMap={normalMap} envMap={envMap} />
                        </mesh>
                    )}
                </>
            }
            
            {params.p_r_s !== 1 &&
                <group name='legs' position={[0, 0, params.p_d / 2 + pillarWidth]}>
                    <mesh name='topLeftBaseRail' position={[ - Temp_F_p_w / 2, params.leanF_p_h + regularHeight - pillarWidth / 2, 0]} rotation={[0, 0, 0]}>
                        <extrudeGeometry args={[railModel(pillarHeight, pillarWidth), extrudeSettings(params.leanF_p_d - pillarWidth)]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </mesh>
                    <mesh name='topRightBaseRail' position={[Temp_F_p_w / 2, params.leanF_p_h + regularHeight - pillarWidth / 2, 0]} rotation={[0, 0, 0]}>
                        <extrudeGeometry args={[railModel(pillarHeight, pillarWidth), extrudeSettings(params.leanF_p_d - pillarWidth)]} />
                        <MaterialTruss normalMap={normalMap} envMap={envMap} />
                    </mesh>
                </group>
            }
                    
            {/* --- loft piece rail model --- */}
            {params.p_r_s === 1 && loftPieceRail.array.length && [1].map(() =>
                <instancedMesh key={loftPieceRail.array.length} instanceMatrix={loftPieceRail} instanceMatrix-needsUpdate={true} args={[null, null, pillarRailDataArr.length * 2]} frustumCulled={false}>
                    <extrudeGeometry args={[railLoftModel(pillarHeight, params.b_l_t_r_pF), extrudeSettings(pillarWidth)]} />
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </instancedMesh>)
            }
            {/* ------------------------- */}

            <mesh name='bottomLeftBaseRail' geometry={leftBottomBaseRailModel}>
                <MaterialTruss normalMap={normalMap} envMap={envMap} />
            </mesh>
            <mesh name='bottomRightBaseRail' geometry={rightBottomBaseRailModel}>
                <MaterialTruss normalMap={normalMap} envMap={envMap} />
            </mesh>
            {outInDistance !== 0 && <> 
                <mesh name='bottomLeftInnerBaseRail' geometry={leftBottomBaseRailModel} position={[outInDistance, 0, 0]}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
                <mesh name='bottomRightInnerBaseRail' geometry={rightBottomBaseRailModel} position={[-outInDistance, 0, 0]}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
            </>}
            {leftPillarModel.leftOuterPillarArr.map((item, index) => 
                leftLegsDataArr[index] &&
                <mesh geometry={item}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
            )}
            {leftPillarModel.leftInnerPillarArr.map((item, index) => 
                leftLegsDataArr[index] && (outInDistance !== 0) &&
                <mesh geometry={item}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
            )}
            {rightPillarModel.rightOuterPillarArr.map((item, index) => 
                rightLegsDataArr[index] &&
                <mesh geometry={item}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
            )}
            {rightPillarModel.rightInnerPillarArr.map((item, index) => 
                rightLegsDataArr[index] && (outInDistance !== 0) &&
                <mesh geometry={item}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
            )}
            <GableLeantoTruss trussType={trussType} normalMap={normalMap} envMap={envMap} trussModelPosInfoArr={const_var.leanToLegPosObj["gableFrontLean"]} hiddenBaseRailIdArr={hiddenBaseRailIdArr}  isFor={"gableFrontLean"} meshDelModel_CSG={meshDelModel_CSG}/>
            <VerticalLeg normalMap={normalMap} envMap={envMap} meshDelModel_CSG={meshDelModel_CSG} />
        </group>
    )
};

export default Legs;